import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledNotifications = styled.div`
  @media only screen and (max-width: ${breakpoints.lg}px) {
    .hide-mobile {
      display: none;
    }

    .mobile-notification-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-weight: 700;

      span {
        font-size: 0.875rem;
      }

      .ant-tag {
        margin: 0;
        width: fit-content;
        padding: 12px 10px;
      }
    }

    .ant-card-body {
      .mobile-card-content-wrapper {
        .mobile-list-card-body-wrapper {
          .mobile-list-card-body-item {
            width: 100%;
            text-align: start !important;

            span {
              font-size: 0.875rem;
            }

            .mobile-notification-message {
              color: ${({ theme }) => theme.textColor} !important;
              font-weight: 700;
            }
          }
        }

        .mobile-list-card-body-triple-section-wrapper {
          border-bottom: 1px solid ${({ theme }) => theme.inputAddonBg};
          padding-bottom: 8px;
        }
      }
    }
  }

  .actions-title {
    text-align: start;
  }

  .actions-right {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }

  .is-clickable {
    cursor: pointer;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: transparent !important;
  }

  .selection-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid ${({ theme }) => theme.borderBottom};
    background: ${({ theme }) => theme.filterBackground};
    border-radius: 10px;
    margin-bottom: 12px;
    position: sticky;
    top: var(--sticky-offset, 0px);
    z-index: 11;
    backdrop-filter: saturate(180%) blur(4px);

    &.is-stuck {
      box-shadow: 0 6px 12px ${({ theme }) => theme.userCompanyBoxShadow};
    }
  }

  .selection-bar .right {
    display: flex;
    gap: 8px;
  }

  .settings-btn {
    font-weight: 700;
    border: 1px solid ${({ theme }) => theme.colorPrimary};
    background: ${({ theme }) => theme.white};
    box-shadow: ${({ theme }) => theme.userCompanyBoxShadow};
    border-radius: 4px;

    img {
      filter: brightness(0);
    }
  }
`;
